<template>
  <div id="cookie-consent-footer">
    <v-card class="pa-5 pa-md-10">
      <v-row
        no-gutters
        align="center">
        <v-col
          cols="12"
          md="7">
          เราใช้คุกกี้เพื่อช่วยให้ไซต์ของเราทำงานได้อย่างถูกต้อง แสดงเนื้อหาและโฆษณาที่ตรงกับ
          ความสนใจของผู้ใช้เปิดให้ใช้คุณสมบัติทางโซเชียลมีเดียและเพื่อวิเคราะห์การเข้าถึง
          ข้อมูลของเรา เรายังแบ่งปันข้อมูลการใช้งานไซต์กับพาร์ทเนอร์โซเชียลมีเดีย
          การโฆษณาและพาร์ทเนอร์การวิเคราะห์ของเราอีกด้วย
        </v-col>
        <v-col
          cols="12"
          md="5">
          <v-row
            justify="center"
            class="pt-7 pt-md-0">
            <v-col
              cols="6"
              sm="4"
              md="5">
              <v-btn
                color="primary"
                block
                large
                outlined
                class="text-body-1"
                @click="() => onChangeDialog(true)"
              >
                การตั้งค่าคุกกี้
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="4"
              md="5">
              <v-btn
                color="primary"
                block
                large
                class="text-body-1"
                @click="acceptAll"
              >
                ยอมรับทั้งหมด
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <cookie-consent-dialog
      :show="showDialog"
      @change="onChangeDialog"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import {
  startAllCookies,
  setAcceptedCookie,
  NECESSARY_COOKIE,
  PERFORMANCE_COOKIE,
  ADVERTISING_COOKIE
} from '@/utils/cookieConsent'

export default {
  name: 'CookieConsentFooter',
  components: {
    CookieConsentDialog: () => import('@/components/CookieConsent/Dialog.vue')
  },
  data() {
    return {
      showDialog: false
    }
  },
  computed: {
    ...mapState('User', ['userProfile'])
  },
  methods: {
    ...mapActions({
      setAcceptAll: 'CookieConsent/setAcceptAll'
    }),
    ...mapWaitingActions('CookieConsent', {
      setAcceptAll: 'app loading'
    }),
    onChangeDialog(value) {
      this.showDialog = value
    },
    async acceptAll() {
      await this.setAcceptAll()

      startAllCookies({
        gtag: this.$gtag
      })

      setAcceptedCookie({
        user: this.userProfile,
        purposes: {
          [NECESSARY_COOKIE]: true,
          [PERFORMANCE_COOKIE]: true,
          [ADVERTISING_COOKIE]: true
        },
        cookies: this.$cookies
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#cookie-consent-footer {
    width: 100%;
    z-index: 10;
    position: fixed;
    bottom: 0px;
    left: 0px;
    border-top: 1px solid rgba(150, 150, 150, 0.1);
}

@media print {
  #cookie-consent-footer {
    width: 0px;
    height: 0px;
    display: none;
    z-index: unset;
  }
}
</style>
